// Copyright (c) 2025 DTCC and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import { useMutation, UseMutationResult } from '@tanstack/react-query';
import { Credential } from '@daml.js/dtc-credential/lib/Dtc/Credential/V3/Credential';
import { AllowList } from '@daml.js/dtc-registry/lib/Dtc/Registry/V3/Rbac/AllowList';
import { ContractId } from '@daml/types';
import { useLedgerApiClient } from '../../../../contexts/LedgerApiContext';
import useRegistrarService from '../../../queries/registry/onboarding/useRegistrarService';

type AddWalletsToAllowListArgs = {
  allowListCid: ContractId<AllowList>;
  credentialCids: ContractId<Credential>[];
};

export const useRegistrarAddWalletsToAllowList: () => UseMutationResult<
  void,
  string,
  AddWalletsToAllowListArgs
> = () => {
  const ledgerApi = useLedgerApiClient();
  const registrarService = useRegistrarService();

  return useMutation({
    mutationKey: ['addWalletsToAllowList', ledgerApi],
    mutationFn: async ({ allowListCid, credentialCids }) => {
      if (!registrarService.data) {
        throw new Error('Registrar service not available');
      }
      return ledgerApi.addWalletsToAllowList(
        registrarService.data.contractId,
        allowListCid,
        credentialCids,
      );
    },
    retry: false,
  });
};
